import React from 'react';
import AppRoutes from './routes';
//import './assets/font/Anton-Regular.ttf';

function App() {
  return (
      <div className="App">
        <AppRoutes />
      </div>
  );
}

export default App;

